import { PricingModulesStatus } from '../../context/contexts/PricingModuleContext';
import { LockedFeatureDisplayConfig, TOOLTIP_PROP_OPTIONS } from '../../components/common/LockedFeatures';
import { POLICY_ACTION_TYPES } from '@silverfort-nodelibs/common/utils/consts';
import { PolicyTemplate } from '../../types/policies';
import {
    isAuthenticationFirewallEnabled,
    isIspmEnabled,
    isItdrEnabled,
    isMfaUsersEnabled
} from '../../components/Policy/utils/utils';
import { DisabledDisplayOptions } from '../../components/SystemSettings/hooks/lockedFeatures/types';
import { RISK_INDICATORS } from '@silverfort-nodelibs/common/utils/insight';

export const getPolicyTemplatesLockedFeatureTooltipConfig = (params: {
    pricingModulesState: PricingModulesStatus | null;
    template: PolicyTemplate;
    hiddenRiskIndicators: string[];
}): LockedFeatureDisplayConfig => {
    const { pricingModulesState, template, hiddenRiskIndicators } = params;
    const isAuthenticationFirewallModuleEnabled = isAuthenticationFirewallEnabled(pricingModulesState);
    const isMfaUsersModuleEnabled = isMfaUsersEnabled(pricingModulesState);
    const isItdrModuleEnabled = isItdrEnabled(pricingModulesState);
    const isIspmModuleEnabled = isIspmEnabled(pricingModulesState);

    if (!isAuthenticationFirewallModuleEnabled && template.supportedActions.includes(POLICY_ACTION_TYPES.DENY.value)) {
        return {
            enabled: false,
            disabledDisplay: DisabledDisplayOptions.TOOLTIP,
            tooltipProps: TOOLTIP_PROP_OPTIONS.AUTHENTICATION_FIREWALL_MODULE_REQUIRED
        };
    }

    if (
        !isMfaUsersModuleEnabled &&
        template.supportedActions.some((action) => action !== POLICY_ACTION_TYPES.DENY.value)
    ) {
        return {
            enabled: false,
            disabledDisplay: DisabledDisplayOptions.TOOLTIP,
            tooltipProps: TOOLTIP_PROP_OPTIONS.MFA_MODULE_REQUIRED
        };
    }

    if (template.risk_enabled) {
        if (!isItdrModuleEnabled && !isIspmModuleEnabled) {
            return {
                enabled: false,
                disabledDisplay: DisabledDisplayOptions.TOOLTIP,
                tooltipProps: TOOLTIP_PROP_OPTIONS.ITDR_AND_ISPM_MODULES_REQUIRED
            };
        }

        if (
            template.risk_indicators?.some(
                (riskIndicator) =>
                    !!RISK_INDICATORS[riskIndicator]?.policyRule &&
                    hiddenRiskIndicators.includes(RISK_INDICATORS[riskIndicator].policyRule as string)
            )
        ) {
            return {
                enabled: false,
                disabledDisplay: DisabledDisplayOptions.TOOLTIP,
                tooltipProps: TOOLTIP_PROP_OPTIONS.ITDR_AND_ISPM_MODULES_REQUIRED
            };
        }
    }

    return { enabled: true };
};
